module.exports = __webpack_public_path__ + "img/payment-with-card.e12fed62.svg";